import React, { useState } from 'react';

import { NavigationTabs } from './NavigationTabs';
import { FacilityPicker } from './components/FacilityPicker';
import { InventorySeparationHeader } from './components/InventorySeparationHeader';

/**
 * Wholesale Inventory Separation Dashboard
 *
 * Main dashboard component for managing wholesale inventory separation,
 * including budget allocation and forecasting across facilities.
 */
export function InventorySeparation() {
    const [selectedFacility, setSelectedFacility] = useState(null);

    const handleFacilityChange = (facility) => {
        setSelectedFacility(facility);
    };

    return (
        <div className="min-h-screen bg-stone-50">
            {/* Negative margin to counteract parent .content margin */}
            <div className="-m-5">
                <InventorySeparationHeader />
                <NavigationTabs selectedFacility={selectedFacility} />
            </div>
            {/* Fixed facility picker */}
            <div className="fixed top-20 right-6 z-50">
                <FacilityPicker onChange={handleFacilityChange} />
            </div>
        </div>
    );
}
